<template>
	<section class="login-history">
		<div class="columns">
			<div class="column">
				<div class="card">
					<header class="card-header">
						<p class="card-header-title">
							Login History
						</p>
					</header>
					<div class="columns">
						<div class="column">
							<h4>Summary</h4>
							<ul>
								<li><span>Logins:</span> {{ logins.length }}</li>
								<li><span>Total Time Logged In:</span> {{ totalDuration }}</li>
							</ul>
						</div>
					</div>
					<div class="column">
						<div class="columns refine">
							<DatePicker 
								:startDate="startDate" 
								:endDate="endDate"
								@startDateInput="updateStartDate"
								@endDateInput="updateEndDate"
								@enter="updateData" />
							<div class="column is-7">
								<div class="columns refine is-mobile">
									<div class="column">
										<div class="field">
											<div class="control">
												<a class="button is-primary is-small" v-on:click="updateData">
												Update </a>
											</div>
										</div>
									</div>
								<div class="column">
									<PageSize v-model="pageSize" @input="$refs.paginator.goToPage(0)" />
                                </div>
								</div>
							</div>
						</div>
					</div>
					<div class="card-table">
						<div class="content">
							<table id="allPsychics" class="table is-narrow is-fullwidth is-striped">
								<thead>
									<tr>
										<th>
											Sign In Date
										</th>
										<th>
											Sign Out Date
										</th>
										<th>
											Duration
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(login, idx) in paginatedData" :key="idx">
										<td>{{ formatTimestamp(login.login) }}</td>
										<td class="">{{ formatTimestamp(login.logout) }}</td>
										<td class="">{{ formatDuration(login.duration) }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
        <Paginator ref="paginator" :itemCount="logins.length" :pageSize="this.pageSize" v-model="pageNumber" />
	</section>
</template>

<script>
	import Paginator from "../Paginator.vue"
	import DatePicker from "../DatePicker.vue"
	import PageSize from "../PageSize.vue"
	import moment from "moment-timezone"
    import lodash from "lodash"

    export default {
		components: {
			Paginator,
			PageSize,
			DatePicker,
		},
		data() {
			return {
				pageSize: 10,
				startDate: moment(Date.now()).add(-7, 'days').valueOf().toString(),
				endDate: Date.now().toString(),
				pageNumber: 0,
				logins: []
			}
        },
        props: {
            id: String
        },
		methods: {
			formatTimestamp(date) {
				return moment.tz(date, moment.tz.guess(true)).format("MM/DD/YYYY hh:mm A")
			},
			formatDuration(duration) {
				const hours = Math.floor(duration / 60)
				const mins = duration - (hours * 60)
				return `${hours}:${mins}`
				/*const d = moment.duration(duration, "minutes")
				return `${d.hours()}:${("0" + d.minutes()).slice(-2)}`*/
			},
			updateStartDate(date) {
				this.startDate = moment(date).valueOf().toString()
			},
			updateEndDate(date) {
				this.endDate = moment(date).valueOf().toString()
			},
			async updateData() {
				this.logins = await this.$root.$data.getters.getLogins(this.$root.$data.state, this.id, this.startDate, this.endDate)
			}
		},
		computed: {
			paginatedData() {
				const start = this.pageNumber * this.pageSize,
					end = start + this.pageSize

				return this.logins.slice(start, end)
			},
			totalDuration() {
				const mins = lodash.sumBy(this.logins, (r) => r.duration)
				return `${Math.floor(mins/60)}:${("0" + Math.floor(mins%60)).slice(-2)}`
			}
		},
		async created() {
            this.logins = await this.$root.$data.getters.getLogins(this.$root.$data.state, this.id)
		}
    }
</script>